import {actions} from "./action-list";
export function timezonesFetched(value) {
    return {
        type: actions.TIMEZONE.DATA_FETCHED,
        value: value
    }
}